
<template>
  <div class="">
    <b-card>
      <div class="row ml-1">
        <label class="font-weight-bold"> {{$t('dashboard.excursions.pending')}}</label>
        <b-button
          @click="goTo(`${routes.excursions.excursionActivities}`)"
          size="sm"
          variant="primary"
          class="ml-auto mr-3 esep-blue-bg text-light"
          v-b-tooltip.hover
          :title="$t('dashboard.excursions.showSubmittedExcursions')"
        >
          <b-icon icon="arrow-right-circle-fill"></b-icon>
        </b-button>
      </div>
      <b-table
        id="excursions-table"
        perPage="5"
        striped
        hover
        borderless
        :items="excursionsList"
        :fields="fields"
        responsive
        show-empty
        class="mt-2"
        thead-class="esep-blue-bg text-light"
        :busy="isLoading"
      >

        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template v-slot:empty="">
          <h6>{{ $t("dashboard.excursions.emptyTable") }}</h6>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import EsepService from "../../services/esep.service";
import { routes } from "../../services/routing.service";
import { handleApiError } from "../../services/error.service";

export default {
  props: {
    unitId: Number
  },
  mounted() {
    this.getSubmittedExcursions();
  },
  watch: {
    unitId(newUnitId) {
      this.selectedUnitId = newUnitId;
      this.getSubmittedExcursions();
    }
  },
  data() {
    return {
      selectedUnitId: Number(this.$store.state.globalUnitId) || this.$store.state.userInfo.orgMember.orgUnit.id,
      excursionsList: [],
      isLoading: false,
      fields: [
        { key: 'type', label: "Είδος", thClass: 'text-left', tdClass: 'text-left', formatter: this.translateExcursionType },
        { key: 'unit.name', label: "Κλιμάκιο", thClass: 'text-left', tdClass: 'text-left' },
        { key: 'branch', label: "Τμήμα", formatter: 'translateBranch', thClass: 'text-left', tdClass: 'text-left' },
        { key: 'leader', label: "Υπεύθυνος", formatter: "formatFullName", thClass: 'text-left', tdClass: 'text-left' },
      ],
      routes: routes
    }
  },
  methods: {
    goTo(link) {
      location.replace(link);
    },
    getSubmittedExcursions() {
      this.isLoading = true;
      EsepService.getExcursionsByCriteria(this.selectedUnitId).then(
        (response) => {
          this.excursionsList = response.data.content;
          this.isLoading = false;
          this.$emit('show-comp', { name: 'excursions', value: true });
        },
        (error) => {
          if([4,5].includes(Math.floor(error.response.status / 100))) {
            this.$emit('show-comp', { name: 'excursions', value: false });
          } else {
            let errorMessage = handleApiError(error);
            this.$emit('error:api', errorMessage);
          }

          this.isLoading = false;
        }
      )
    },
    formatFullName(member) {
      return member ? member.surName + " " + member.firstName : "-";
    },
    translateExcursionType(value) {
      return this.$t(`excursionTypeEnums.${value}`);
    },
    translateBranch(value) {
      return this.$t(`common.section.${value}`)
    }

  }
}
</script>

<style></style>